<script lang="ts" setup>
  import { ref, computed } from 'vue';
  import { useRoute, useHttpClient, useTranslator } from '@othercommerce/foundation';

  const signUpEmail = ref(false);
  const route = useRoute();
  const http = useHttpClient();
  const translator = useTranslator();

  const privacyPolicy = computed(() => {
    return translator.trans('SHOP.COMMON.MESSAGE.NEWSLETTER_PRIVACY_NOTICE', { url: route('web.privacyPolicy.index') });
  });

  function handleSubmit(data: any) {
    const request = http.post(route('web.newsletter.store'), data);

    return request.then(() => {
      signUpEmail.value = true;
    });
  }
</script>
<template>
  <div class="newsletter">
    <template v-if="!signUpEmail">
      <FormController ref="form" v-slot="{ submit, processing }" @submit="handleSubmit">
        <div class="newsletter__content">
          <SfFormInput :label="$t('SHOP.COMMON.LABEL.EMAIL')" name="email" required />
          <SfButton :loading="processing" class="newsletter__btn" primary type="submit" @click="submit">
            {{ $t('SHOP.COMMON.ACTION.NEWSLETTER_SIGN_UP') }}
          </SfButton>
        </div>
        <div class="newsletter__consent">
          <SfFormSwitch name="acceptance_rodo" required>
            <span v-html="privacyPolicy" />
          </SfFormSwitch>
        </div>
      </FormController>
    </template>
    <template v-else>
      <p class="subscribed">{{ $t('SHOP.COMMON.MESSAGE.NEWSLETTER_SUBSCRIBED') }}</p>
    </template>
  </div>
</template>
<style lang="scss">
  .newsletter {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;

    &__content {
      width: 100%;
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
    }

    &__consent {
      --sf-switch-line-height: 1.25rem;

      a {
        text-decoration: underline;
      }
    }

    .subscribed {
      font-weight: var(--font-weight-semi);
      font-size: 1rem;
      text-align: center;
      color: var(--sf-status-color-success);
      background: var(--sf-status-background-success);
      border: 1px solid var(--sf-status-color-success);
      border-radius: var(--border-radius);
      padding: 0.5rem 1rem;
    }
  }

  @media (max-width: 1200px) {
    .newsletter {
      &__content {
        display: contents;
      }

      &__btn {
        order: 1;
      }
    }
  }

  @media (max-width: 767px) {
    .newsletter {
      border: none;
      padding: 0 0.625rem;
    }
  }
</style>
